var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQueue(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M416.38,83.29C352.16-7.9,254.11,189.72,217.32,190.08c-55.86.55-45.32-87.91-104.93-87.72-83.86.26-70.4,87.92-63.82,120.26,6.65,32.66,32.15,106.67,101.27,108.91,105.58,3.43,87.53-73.23,148.72-97.34,28.86-11.37,46.2,28.36,91.86,11.43C470.06,216.11,439.32,115.87,416.38,83.29Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.38,83.29C352.16-7.9,254.11,189.72,217.32,190.08c-55.86.55-45.32-87.91-104.93-87.72-83.86.26-70.4,87.92-63.82,120.26,6.65,32.66,32.15,106.67,101.27,108.91,105.58,3.43,87.53-73.23,148.72-97.34,28.86-11.37,46.2,28.36,91.86,11.43C470.06,216.11,439.32,115.87,416.38,83.29Z",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-15"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-15",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.87,125.32c-2,2.93-1.37,5.06.32,10.88.7,2.41,1.78,4.81,5.1,1.26s6.55-10.3,2.29-11.44A22.11,22.11,0,0,0,121.87,125.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "121.78 406.89 114.36 406.89 114.04 389.68 121.47 389.68 121.78 406.89",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "166.39 406.89 158.96 406.89 155.65 389.68 163.08 389.68 166.39 406.89",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.45,406h8.35a.63.63,0,0,1,.62.5l1.31,6.61a1.13,1.13,0,0,1-1.12,1.32c-2.92,0-4.33-.22-8-.22-2.26,0-6.91.23-10,.23s-3.45-3.08-2.17-3.36c5.76-1.25,8-3,9.83-4.63A1.85,1.85,0,0,1,158.45,406Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.43,406h8.11a.63.63,0,0,1,.62.5l1.3,6.61a1.11,1.11,0,0,1-1.1,1.32c-2.92,0-7.15-.22-10.83-.22-4.3,0-8,.23-13.06.23-3,0-3.82-3.08-2.54-3.36,5.84-1.27,10.59-1.41,15.69-4.5A3.49,3.49,0,0,1,114.43,406Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.36,171.91l-10.14-3.25s-10.48,24.26-14,25.77c-4.77,2-11.44,8.53-16.18,12.48-.15,1.25.43,4.54,1.18,5.4,8.55-2,19.21-6.9,22.7-10.13C107.9,194.81,116.36,171.91,116.36,171.91Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.73,166.33c2.85,6.5-8.6,27.14-8.6,27.14l-15.15-7a93.76,93.76,0,0,1,7.51-18.14C107.25,160,115.6,159.19,118.73,166.33Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.73,166.33c2.85,6.5-8.6,27.14-8.6,27.14l-15.15-7a93.76,93.76,0,0,1,7.51-18.14C107.25,160,115.6,159.19,118.73,166.33Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106,177.65A80.65,80.65,0,0,0,102.57,190l7.56,3.5s8.06-14.52,9-23C114.72,167.56,108.76,170.33,106,177.65Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.07,206.19l-8.84,1.41,2.29,9.33a32.89,32.89,0,0,0,8.51-5.3Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "60.58 211.55 63.8 216.69 70.52 216.93 68.23 207.6 60.58 211.55",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "114.04 389.69 114.2 398.56 121.63 398.56 121.47 389.69 114.04 389.69",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "163.08 389.69 155.65 389.69 157.36 398.56 164.79 398.56 163.08 389.69",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109,162.11s-9.32,25.53-2,67.31h39.73c.42-6.1-2.68-38.95,3.91-67.69a102.12,102.12,0,0,0-13.26-1.68,146.31,146.31,0,0,0-16.89,0A76.15,76.15,0,0,0,109,162.11Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109,162.11s-9.32,25.53-2,67.31h39.73c.42-6.1-2.68-38.95,3.91-67.69a102.12,102.12,0,0,0-13.26-1.68,146.31,146.31,0,0,0-16.89,0A76.15,76.15,0,0,0,109,162.11Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.84,168.83c-.77,4.73.44,16,4.62,29.12A191.42,191.42,0,0,1,150,164.59v-.06C147.42,164.27,142.59,164.39,141.84,168.83Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.57,144.25c-1.2,5.44-1.89,12.17,1.82,15.8,0,0-2.32,5.51-12.42,5.51-9.23,0-4.47-5.51-4.47-5.51,6.09-1.45,6-8.94,5-13.16Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.49,165.13l-2.18,2.42a.63.63,0,0,0-.14.63l.7,2.13a.61.61,0,0,0,.56.42l2.35.12a.64.64,0,0,0,.57-.29l1.41-2.07a.62.62,0,0,0,0-.77l-2.28-2.6A.63.63,0,0,0,124.49,165.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125,164.59a12.88,12.88,0,0,1,1.8,6.19s12.76-4.46,12.33-11c0,0-1.77-1.07-2.89-1.94C136.22,157.85,135.69,162,125,164.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125,164.59a18.15,18.15,0,0,0-2.61,5.8s-5.64-3.88-3.76-10.34a21.86,21.86,0,0,1,3.27-1S121,163.19,125,164.59Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124,169.49c-.36-.12-4.93,26.68-4.42,31.51a40.4,40.4,0,0,0,2.77,13s2-4.94,2.18-13.33c0-8.28.09-26.34.82-31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125.5,146.89a16.2,16.2,0,0,1-.26,8.92A9.6,9.6,0,0,0,128,155c3.46-1.61,5.2-4.14,7.05-7.91.16-1,.34-1.9.55-2.82Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.91,141a6.77,6.77,0,0,0,3.52,4c2.2,1,3.74-.89,3.49-3.2-.22-2.09-1.64-5.14-4-5.19A3.24,3.24,0,0,0,116.91,141Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.91,141a6.77,6.77,0,0,0,3.52,4c2.2,1,3.74-.89,3.49-3.2-.22-2.09-1.64-5.14-4-5.19A3.24,3.24,0,0,0,116.91,141Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.14,137.63c-2.15,7.12-3,11.4-7.53,14.32-6.74,4.39-14.76-.83-14.76-8.41,0-6.82,3.52-17.32,11.18-18.68A9.83,9.83,0,0,1,140.14,137.63Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136,128.78c-2,2.93-1.36,5.06.33,10.88.7,2.41,1.78,4.81,5.09,1.26s6.56-10.3,2.29-11.44A22.11,22.11,0,0,0,136,128.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M136.81,131c-4.6-.56-16-1.52-15.15-7.46s8.58-4.15,8.58-4.15-3.83,2,4.21,3.55,12.11,6.31,8.48,8.22A5.6,5.6,0,0,1,136.81,131Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.48,146.29a7.11,7.11,0,0,1-5,2.11c-2.45,0-3-2.35-1.7-4.33,1.14-1.79,3.79-3.95,6-3S143.08,144.64,141.48,146.29Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.19,143.55c-.21,3.71.14,8.7,3,9.69s10.36.67,12.74-.63c3.72-2,5.38-10.51,7.11-12.12s-1.54-2.38-1.54-2.38-2.2,5.44-5.79,5.69S117.45,138.86,117.19,143.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M133.12,229.42s-.79,9.34-1.79,22c-1.15,14.35-2.56,33-3.4,47.17,0,.08,0,.14,0,.2-.16,2.69-.3,5.22-.42,7.53-1.12,23.15-3.44,90.52-3.44,90.52H111.47s-6.33-68.75-6.6-92.31c-.25-22.66,2.13-75.11,2.13-75.11Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M125,393c.05,0-.11,4.11-.11,4.11h-14.5l-.5-4.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.33,251.42c-1.15,14.35-2.56,33-3.4,47.17,0,.08,0,.14,0,.2-3.08-13.46-4.33-30.2-3.89-57.76Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.1,229.42s7,53.68,11.15,75c4.5,23.29,21.69,92.47,21.69,92.47h13.61s-10.74-67.3-13.07-90.36c-2.52-25-7.74-77.06-7.74-77.06Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.63,393.29c.06,0,.59,3.8.59,3.8h-15L152,392.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.26,388.8a.13.13,0,0,1-.12-.11c-.1-.69-9.78-60.62-11.87-81.34-2.27-22.49-7-72.34-7-72.84a.13.13,0,0,1,.11-.14.12.12,0,0,1,.14.11c.05.5,4.77,50.35,7,72.84,2.09,20.71,11.77,80.64,11.87,81.33a.14.14,0,0,1-.11.15Z",
    style: {
      fill: "#fff",
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.84,137.29c-.14.59-.56,1-.94.92s-.57-.63-.43-1.21.56-1,.94-.92S129,136.71,128.84,137.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.28,135.87c-.14.58-.56,1-.94.91s-.58-.62-.44-1.21.56-1,.94-.92S122.41,135.28,122.28,135.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.29,136.61a22.16,22.16,0,0,1-4,4.43,3.37,3.37,0,0,0,2.65,1.13Z",
    style: {
      fill: "#ed847e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.28,146.19a.17.17,0,0,1-.13-.21.18.18,0,0,1,.22-.13,4.81,4.81,0,0,0,4.21-.88.18.18,0,0,1,.25,0,.19.19,0,0,1,0,.25A5.07,5.07,0,0,1,124.28,146.19Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.33,135.58a.31.31,0,0,1-.24-.19,2.7,2.7,0,0,0-1.92-1.63.34.34,0,0,1-.28-.4.36.36,0,0,1,.4-.3,3.35,3.35,0,0,1,2.44,2,.36.36,0,0,1-.18.47A.34.34,0,0,1,131.33,135.58Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.88,132.87a.31.31,0,0,1-.13-.08.35.35,0,0,1,0-.49,3.55,3.55,0,0,1,3-1.23.34.34,0,0,1,.29.4.37.37,0,0,1-.41.3h0a2.82,2.82,0,0,0-2.36,1A.35.35,0,0,1,119.88,132.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.16,174l10.32-3.36s9.5,24.2,13,25.61c4.79,1.91,14.52,7,20.57,8.22.69,1,1.62,4.16,1.33,5.27-8.67,2.25-26.32-2.5-29.8-5.62C151.68,197,144.16,174,144.16,174Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.65,161.73c7,1,14.46,25.38,14.46,25.38l-15,8.34s-6.22-11.59-9.21-20.19C137.79,166.25,143.14,160.63,150.65,161.73Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.65,161.73c7,1,14.46,25.38,14.46,25.38l-15,8.34s-6.22-11.59-9.21-20.19C137.79,166.25,143.14,160.63,150.65,161.73Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M156,407.32a2.24,2.24,0,0,1-1.43-.37,1.07,1.07,0,0,1-.34-.94.57.57,0,0,1,.32-.49c.82-.42,3.19,1.05,3.46,1.22a.19.19,0,0,1,.07.18.18.18,0,0,1-.13.14A9.21,9.21,0,0,1,156,407.32Zm-1.07-1.53a.53.53,0,0,0-.23,0,.24.24,0,0,0-.12.21.71.71,0,0,0,.23.64,3.57,3.57,0,0,0,2.63.13A6.85,6.85,0,0,0,154.9,405.79Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.87,407.06a.13.13,0,0,1-.08,0c-.76-.42-2.2-2-2-2.87a.6.6,0,0,1,.58-.46.92.92,0,0,1,.74.22c.85.71,1,2.85,1,2.94a.15.15,0,0,1-.08.16A.17.17,0,0,1,157.87,407.06Zm-1.42-3h-.08c-.23,0-.25.13-.26.17-.11.49.81,1.72,1.56,2.3a4.19,4.19,0,0,0-.82-2.33A.62.62,0,0,0,156.45,404.05Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.3,407.32a2.79,2.79,0,0,1-1.79-.45,1,1,0,0,1-.31-.86.59.59,0,0,1,.3-.47c.92-.5,3.87,1,4.2,1.19a.17.17,0,0,1,.09.18.18.18,0,0,1-.14.15A13.39,13.39,0,0,1,111.3,407.32Zm-1.3-1.53a.75.75,0,0,0-.33.06.23.23,0,0,0-.12.19.65.65,0,0,0,.2.57c.45.4,1.67.47,3.32.2A9.54,9.54,0,0,0,110,405.79Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M113.61,407.06h-.07c-.89-.41-2.62-2-2.47-2.85,0-.2.19-.45.67-.49a1.21,1.21,0,0,1,1,.3c.92.77,1.08,2.77,1.08,2.86a.16.16,0,0,1-.08.16A.17.17,0,0,1,113.61,407.06Zm-1.74-3h-.1c-.32,0-.34.15-.35.19-.1.51,1.08,1.77,2,2.32a4,4,0,0,0-.92-2.29A.93.93,0,0,0,111.87,404.05Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.73,209.86l7.07.34-3.75-7.71s-6.2-.09-7.21,4.67Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "201.53 206.47 197.78 199.66 192.05 202.49 195.8 210.2 201.53 206.47",
    style: {
      fill: "#ffc3bd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M208.92,149.29c-.71-5.18-14.55-9.18-21-3.26-8.7,7.95-7.31,32.87-7.31,46.37,12.88-3.17,32.46-2.41,35.88-.54C217.22,185.65,217.05,150.81,208.92,149.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.24,197.55c-.14,2.36-.4,4.51-.69,6.74s-.68,4.41-1.11,6.61a92.17,92.17,0,0,1-3.55,13c-.38,1.07-.83,2.13-1.24,3.19s-.9,2.09-1.47,3.18a36.06,36.06,0,0,1-4,5.9,55.12,55.12,0,0,1-9.86,9.28l-2.74-3a109.94,109.94,0,0,0,7.27-10.15,35.89,35.89,0,0,0,2.71-5.19c.37-.86.72-1.86,1.09-2.79s.65-1.93,1-2.9a107.94,107.94,0,0,0,2.86-12.09c.35-2.06.66-4.13.95-6.21s.52-4.2.69-6.15Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.19,187.86c-2.81.72-4.39,19.31-4.39,19.31l7.47,4.5s4.52-13.74,3.83-19.67C183.6,187.69,179.31,187.32,177.19,187.86Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157,242.52l-6.43,4.83,7.89,1.81s3.4-3.81,2.27-6.92Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "148.86 253.81 155.55 254.97 158.49 249.16 150.6 247.35 148.86 253.81",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "192.21 406.34 185.79 406.34 181.83 377.11 192.76 377.11 192.21 406.34",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "192.47 392.25 183.88 392.25 181.83 377.11 192.76 377.11 192.47 392.25",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "241.92 395.8 235.72 397.4 223.14 370.76 233.81 367.74 241.92 395.8",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "238.1 382.57 229.62 384.48 223.14 370.76 233.81 367.74 238.1 382.57",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.23,396.31l8.24-3.49a.61.61,0,0,1,.79.25l3.71,6.11a1.28,1.28,0,0,1-.62,1.8c-2.89,1.17-4.35,1.59-8,3.13-2.22.95-5.38,2.56-8.46,3.87s-4.53-1.67-3.36-2.49c5.21-3.67,5.4-5.76,6.64-8.21A2.15,2.15,0,0,1,234.23,396.31Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.94,405.42h8.94a.64.64,0,0,1,.64.55l1,7.07a1.29,1.29,0,0,1-1.28,1.42c-3.12-.06-4.62-.24-8.55-.24-2.42,0-7.43.25-10.77.25s-3.52-3.3-2.13-3.6c6.24-1.34,8.7-3.19,10.8-5A2.06,2.06,0,0,1,184.94,405.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M176.7,187.85s-3.8,1.33,3.8,48.05h32.33c-.54-13.16-.56-21.28,5.73-48.28a94.38,94.38,0,0,0-13.73-1.81,102.64,102.64,0,0,0-14.68,0C183.85,186.38,176.7,187.85,176.7,187.85Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.51,204.35h0s-.07,0-.08-.06c-2-3.46-7.08-6.18-7.13-6.21a.12.12,0,0,1-.05-.17.13.13,0,0,1,.17,0s5,2.72,7.14,6.17c2.12-1.86,8.92-10.28,8.1-17.52a.12.12,0,0,1,.11-.13h0a.12.12,0,0,1,.13.11c.84,7.47-6.3,16.16-8.3,17.83A.11.11,0,0,1,200.51,204.35Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M183.74,203a.11.11,0,0,1-.08,0,4.39,4.39,0,0,1-1.09-3.08c-.27-3.92,1.34-10.41,3.89-13.21a.13.13,0,0,1,.18,0,.12.12,0,0,1,0,.17c-2.51,2.77-4.09,9.16-3.83,13a4.43,4.43,0,0,0,.9,2.8c1.66-2.25,6.3-5,6.5-5.09a.13.13,0,1,1,.12.22c-.05,0-5,2.9-6.5,5.13a.15.15,0,0,1-.09.06Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M203.38,169.28c-.93,4.72-1.85,13.38,1.45,16.53,0,0,1.83,11.11-13.24,11.11-12.45,0-1.44-11.11-1.44-11.11,5.27-1.26,5.13-5.17,4.22-8.84Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M199.7,172.42,194.37,177a15.07,15.07,0,0,1,.45,2.6c2-.29,4.78-2.5,5-4.6A6.8,6.8,0,0,0,199.7,172.42Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.36,160.61c-1.85,7.68-2.47,11-7.1,14.26-7,4.95-16,1-16.47-7.08-.43-7.27,2.67-18.61,10.82-20.36A10.78,10.78,0,0,1,208.36,160.61Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M202.35,151.64c.89,7.5,1.25,15.06,6.57,13.22s.52-13.22.52-13.22Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M185.08,154.08a34.67,34.67,0,0,1,23.27.93c-1-3.66-1.61-6.61-6.12-8S187.34,147.25,185.08,154.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M180.5,235.9s-6.28,61.32-5.76,85.6c.54,25.25,6.27,65.9,6.27,65.9l13-.41s-.41-38.76.54-63.56c1-27,9.63-87.53,9.63-87.53Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "195.38 389.25 179.73 389.25 178.58 385.22 196.11 384.73 195.38 389.25",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M194.45,251.15c-7.95,16-1.6,45.12,1.21,56,1.44-16.29,3.87-36.19,5.76-50.81C200.22,248,198.11,243.79,194.45,251.15Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189,235.9s7.32,63.75,12.85,84.22c6.57,24.3,24.28,60.47,24.28,60.47l12.09-3.48s-10.3-42.54-15.32-55.34c-10.72-27.32-1.54-68-10.11-85.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "240.45 378.67 226.02 382.67 223.42 378.97 239.43 373.63 240.45 378.67",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.39,160.77c-.12.63-.54,1.08-.95,1s-.66-.65-.55-1.28.54-1.08,1-1S195.5,160.13,195.39,160.77Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.24,159.5c-.11.63-.54,1.09-1,1s-.66-.64-.55-1.27.54-1.09.95-1S188.35,158.87,188.24,159.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M187.87,158.29l-1.44-.71S187,158.91,187.87,158.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M190.27,160.85a17.44,17.44,0,0,1-3,3.64,2.78,2.78,0,0,0,2.18.82Z",
    style: {
      fill: "#ed893e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.82,168.29a6,6,0,0,1-1.08-.1.18.18,0,0,1-.15-.22.19.19,0,0,1,.22-.15,5.13,5.13,0,0,0,4.43-1.23.19.19,0,1,1,.27.26A5.28,5.28,0,0,1,192.82,168.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.69,166.4a5.77,5.77,0,0,1-3.13,3.11c-1.88.76-3-.87-2.7-2.76.3-1.7,1.64-4.14,3.62-4.09A2.59,2.59,0,0,1,208.69,166.4Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M198.16,156.54a.39.39,0,0,1-.28-.12,3,3,0,0,0-2.54-1,.39.39,0,0,1-.44-.31.37.37,0,0,1,.31-.43,3.71,3.71,0,0,1,3.22,1.2.38.38,0,0,1,0,.53A.4.4,0,0,1,198.16,156.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186.46,155.57a.36.36,0,0,1-.26-.11.38.38,0,0,1,0-.53,3.71,3.71,0,0,1,3.23-1.19.36.36,0,0,1,.3.44.37.37,0,0,1-.44.3,3,3,0,0,0-2.54,1A.37.37,0,0,1,186.46,155.57Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.06,196.13a122.22,122.22,0,0,1,4.71,13.73,80.8,80.8,0,0,1,2.9,14.47c.08.62.11,1.27.13,1.91l0,1v.24c0,.1,0,.11,0,.31a6.48,6.48,0,0,1-.06.9,10.72,10.72,0,0,1-2,4.75,33,33,0,0,1-5.32,5.71,78.08,78.08,0,0,1-11.88,8.42l-2.34-3.28c3.39-3.11,6.82-6.3,9.8-9.63a32,32,0,0,0,3.82-5,4.24,4.24,0,0,0,.65-1.72s0,0,0,0l0-.34-.09-.79c-.05-.53-.1-1.05-.2-1.59A94.76,94.76,0,0,0,219,212.14c-1.36-4.33-2.9-8.74-4.51-12.93Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.53,187.62c3.17,1.29,7.14,18.65,7.14,18.65l-6.74,5.53s-6.35-12.94-6.63-18.91C212.08,188.41,215.73,186.47,218.53,187.62Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.6,398.82a1.08,1.08,0,0,1-.57-.75.63.63,0,0,1,.14-.63c.69-.75,3.52-.26,3.85-.2a.19.19,0,0,1,.15.14.2.2,0,0,1-.08.19c-.85.63-2.42,1.63-3.38,1.3Zm2.9-1.29c-1.14-.16-2.69-.23-3.05.16a.26.26,0,0,0,0,.28.68.68,0,0,0,.44.54C231.35,398.69,232.33,398.33,233.5,397.53Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M232.7,397.18c-.83-.4-1.68-1-1.8-1.58a.66.66,0,0,1,.38-.73,1,1,0,0,1,.83-.08c1.1.36,2,2.47,2,2.56a.19.19,0,0,1,0,.18.17.17,0,0,1-.17.08A4.46,4.46,0,0,1,232.7,397.18Zm-.59-2-.12-.05a.63.63,0,0,0-.52.05c-.21.12-.22.24-.2.33.12.55,1.45,1.38,2.38,1.64A4.84,4.84,0,0,0,232.11,395.19Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182,406.81a3,3,0,0,1-1.93-.49,1,1,0,0,1-.34-.91.62.62,0,0,1,.32-.51c1-.53,4.15,1.09,4.5,1.28a.16.16,0,0,1,.1.19.19.19,0,0,1-.15.16A13.81,13.81,0,0,1,182,406.81Zm-1.42-1.64a.82.82,0,0,0-.35.06.25.25,0,0,0-.13.21.68.68,0,0,0,.22.6c.48.44,1.79.51,3.56.22A10.36,10.36,0,0,0,180.53,405.17Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M184.42,406.53h-.08c-1-.43-2.83-2.15-2.68-3,0-.22.19-.48.71-.53a1.36,1.36,0,0,1,1,.32c1,.83,1.19,3,1.2,3.07a.18.18,0,0,1-.19.2Zm-1.9-3.22h-.11c-.35,0-.37.17-.38.22-.08.54,1.19,1.89,2.16,2.48a4.41,4.41,0,0,0-1-2.46A1,1,0,0,0,182.52,403.31Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.32,234l.82,2.89c.12.23-.15.46-.52.46H180.34c-.29,0-.53-.15-.55-.33l-.29-2.89c0-.2.23-.37.55-.37h32.74A.59.59,0,0,1,213.32,234Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M213.32,234l.82,2.89c.12.23-.15.46-.52.46H180.34c-.29,0-.53-.15-.55-.33l-.29-2.89c0-.2.23-.37.55-.37h32.74A.59.59,0,0,1,213.32,234Z",
    style: {
      fill: "#263238",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M208.92,237.66h.88c.17,0,.3-.09.29-.2l-.41-3.76c0-.11-.16-.2-.34-.2h-.88c-.17,0-.3.09-.29.2l.41,3.76C208.59,237.57,208.74,237.66,208.92,237.66Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.8,237.66h.88c.18,0,.31-.09.3-.2l-.41-3.76c0-.11-.17-.2-.34-.2h-.88c-.18,0-.31.09-.3.2l.41,3.76C182.48,237.57,182.63,237.66,182.8,237.66Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.86,237.66h.88c.17,0,.31-.09.29-.2l-.41-3.76c0-.11-.16-.2-.34-.2h-.87c-.18,0-.31.09-.3.2l.41,3.76C195.53,237.57,195.69,237.66,195.86,237.66Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.15,243.57l-8.57.74,5.73,5.72s4.91-1.43,5.59-4.66Z",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "195.68 248.87 200.73 253.4 207.52 249.58 200.58 244.31 195.68 248.87",
    style: {
      fill: "#ffb573"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195,159.56l-1.44-.71S194.15,160.17,195,159.56Z",
    style: {
      fill: "#263238"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-4--inject-15"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "354.41 404.46 346.94 403.39 347.43 385.83 354.89 386.9 354.41 404.46",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "406.92 406.78 399.39 406.78 397.51 389.32 405.05 389.32 406.92 406.78",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.77,405.9H408a.67.67,0,0,1,.64.52l1.49,6.7a1.11,1.11,0,0,1-1.11,1.34c-3,0-5.11-.23-8.83-.23-2.3,0-9.2.24-12.37.24s-3.58-3.13-2.28-3.41c5.81-1.27,10.18-3,12-4.69A1.87,1.87,0,0,1,398.77,405.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.12,402.54l8.15,1.16a.67.67,0,0,1,.56.6l.53,6.85a1.1,1.1,0,0,1-1.27,1.17c-2.93-.47-7.15-1.25-10.85-1.78-4.32-.62-8.08-.92-13.15-1.64-3.06-.44-3.47-3.66-2.14-3.76,6-.44,10.8.11,16.29-2.28A3.42,3.42,0,0,1,347.12,402.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.08,175.76c-.39,5.22-1,10.3-1.77,15.44-.38,2.56-.83,5.12-1.31,7.68-.24,1.28-.49,2.56-.77,3.84l-.43,1.92-.21,1c-.08.32-.2.74-.29,1.11a49.09,49.09,0,0,1-3,7.9q-1.72,3.62-3.65,7a140,140,0,0,1-8.37,13.16L346.31,232l5.6-14c.91-2.33,1.76-4.66,2.55-7a48.84,48.84,0,0,0,1.84-6.58c0-.26.09-.46.14-.76l.12-.93.25-1.84.46-3.71.83-7.47,1.6-15Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M365,168c-7,1.78-10.25,26.56-10.25,26.56l17.3,2.57s1.65-6.67,4.31-15.8C378,175.61,373.69,165.77,365,168Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M347.61,230.66l-6.12,5.21,7.87,3.81a8.08,8.08,0,0,0,2.42-6.15Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "338.12 240.64 345.04 243.31 349.36 239.68 341.49 235.87 338.12 240.64",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "347.44 385.83 347.18 394.89 354.65 395.96 354.9 386.9 347.44 385.83",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "405.05 389.32 397.51 389.32 398.48 398.32 406.02 398.32 405.05 389.32",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.9,169.77a169.48,169.48,0,0,0-4.29,24.89c-.6,5.85-.91,11.43-1.08,16.49-.38,11.86.06,20.89-.23,23.95-5.9-.29-28.14-1.38-40.27-2-1.19-59.24,3.68-65.05,3.68-65.05a77.61,77.61,0,0,1,9.6-1.38c.68-.06,1.37-.1,2.07-.13a148.32,148.32,0,0,1,17.12.85c1.08.1,2.17.24,3.23.39C402.13,168.56,406.9,169.77,406.9,169.77Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373,166.62c.94,4.49,10.46,35.49,29.11,45.91a.52.52,0,0,1,.27.43c.06.94.08,2.15.09,2.86a.54.54,0,0,1-.61.54c-2.19-.3-10.44-2.94-22.19-21.8-5.79-9.3-9.8-23.91-10.45-27a.58.58,0,0,1,.42-.68l2.65-.7A.57.57,0,0,1,373,166.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.84,183.47c1.11,2.48-4.19,13.14,2.57,24s12.65,1.93,19.56,5.91C389,204.65,374.84,183.47,374.84,183.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.41,211l-.1,0c-12.36-5.71-14.5-23.24-14.52-23.41a.25.25,0,0,1,.22-.28.24.24,0,0,1,.27.22c0,.18,2.13,17.43,14.24,23a.25.25,0,0,1-.11.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397,180.82a31.81,31.81,0,0,0,5.33,17.33c.09-1.15.2-2.32.32-3.49.45-4.4,1.05-8.95,1.87-13.56Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.76,148c-1.35,5.45-2.93,15.49.74,19.36A17.14,17.14,0,0,1,380,172c-4.73-.33-4.81-3.66-3.66-5.44,6.22-1.16,6.28-5.73,5.43-10.06Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.29,151.49l-6.48,5a17.06,17.06,0,0,1,.38,3.06c2.36-.22,5.71-2.64,6.08-5.08A8.18,8.18,0,0,0,388.29,151.49Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M392.55,138.22c.51,7.46,1.18,11.81-2.06,16.09-4.89,6.45-14.47,4.24-17.19-2.92-2.46-6.45-2.87-17.57,4-21.46A10.2,10.2,0,0,1,392.55,138.22Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M380.27,150.37h0a5.5,5.5,0,0,0,4.21-2.8.2.2,0,0,0-.09-.25.19.19,0,0,0-.26.09,5.19,5.19,0,0,1-3.91,2.57.21.21,0,0,0-.17.22A.2.2,0,0,0,380.27,150.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M385.8,133.12c.31,3.28,2.95,6.6,2.62,8.72a7.13,7.13,0,0,1-.93,2.64l4.84,1.12s13.83-14.78,2.89-17.62c-5.06-9.77-26.05-12.66-30.39-4-4.61,9.13,8.05,11.29,8.05,11.29S377.83,131.73,385.8,133.12Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397,146a7.11,7.11,0,0,1-4,3.68c-2.34.85-3.7-1.21-3.19-3.52.45-2.08,2.21-5,4.64-4.87A3.2,3.2,0,0,1,397,146Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M344.63,392.76l12.64,1.81s7.33-46,11.12-72.69c1-7.07,2.66-17.05,4.82-27.7,2.71-13.42,6.17-27.93,9-39.3,3-12,5.29-20.46,5.29-20.46L361,233.11s-13,62.25-14.49,85.2C345,342.18,344.63,392.76,344.63,392.76Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.21,294.18c2.71-13.42,6.17-27.93,9-39.3L379.35,249C373,257,371.67,281.1,373.21,294.18Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M375.31,233.82s4.17,64.67,7.35,86.52c3.49,23.93,12.34,76.24,12.34,76.24h13.8s-1.23-49.3-4.77-72.76c-4-26.56-2.74-88.71-2.74-88.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "393.34 396.88 409.6 396.88 409.6 392.02 391.43 391.71 393.34 396.88",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "343.8 392.94 358.06 394.99 359.44 389.99 343.18 387.63 343.8 392.94",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M381.59,141.75c.08.6-.18,1.13-.57,1.18s-.78-.4-.86-1,.18-1.13.58-1.18S381.51,141.14,381.59,141.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.78,142.63c.07.6-.18,1.13-.58,1.18s-.77-.39-.85-1,.18-1.13.57-1.18S374.7,142,374.78,142.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M377,142.65a21.89,21.89,0,0,1-2.21,5.53c1.19.86,3,0,3,0Z",
    style: {
      fill: "#ed847e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.42,139.27a.35.35,0,0,1-.36-.09,2.84,2.84,0,0,0-2.42-.89.35.35,0,0,1-.42-.28.35.35,0,0,1,.28-.42,3.56,3.56,0,0,1,3.07,1.09.35.35,0,0,1,0,.5A.42.42,0,0,1,383.42,139.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.55,140.66a.41.41,0,0,1-.22,0,.36.36,0,0,1-.23-.45,3.55,3.55,0,0,1,2.29-2.33.36.36,0,1,1,.18.69h0a2.87,2.87,0,0,0-1.79,1.86A.33.33,0,0,1,371.55,140.66Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.27,407.22a2.32,2.32,0,0,1-1.45-.38,1.1,1.1,0,0,1-.37-.95.56.56,0,0,1,.31-.5c.84-.43,3.26,1.06,3.54,1.23a.18.18,0,0,1,.08.18.17.17,0,0,1-.13.15A8.77,8.77,0,0,1,396.27,407.22Zm-1.12-1.56a.53.53,0,0,0-.23,0,.23.23,0,0,0-.11.21.72.72,0,0,0,.24.65,3.61,3.61,0,0,0,2.68.14A7.26,7.26,0,0,0,395.15,405.66Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.2,407a.13.13,0,0,1-.08,0c-.78-.42-2.29-2.07-2.13-2.91a.58.58,0,0,1,.57-.47,1,1,0,0,1,.76.23c.87.71,1.06,2.89,1.06,3a.17.17,0,0,1-.08.17Zm-1.52-3.05h-.08c-.23,0-.25.14-.26.18-.09.5.87,1.75,1.64,2.34a4.21,4.21,0,0,0-.89-2.36A.61.61,0,0,0,396.68,403.9Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.25,403.46h0c-1.24.06-3.42,0-4.14-.79a1,1,0,0,1-.2-.91.57.57,0,0,1,.36-.43c1-.36,3.75,1.58,4.07,1.8a.19.19,0,0,1,.07.2A.18.18,0,0,1,346.25,403.46Zm-3.84-1.8-.05,0a.22.22,0,0,0-.14.17.64.64,0,0,0,.14.6c.4.47,1.61.72,3.3.68C344.55,402.39,343,401.52,342.41,401.66Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.25,403.46a.22.22,0,0,1-.14,0c-.84-.54-2.4-2.4-2.14-3.23.06-.19.24-.42.73-.4a1.34,1.34,0,0,1,.94.45c.83.91.75,2.95.74,3a.19.19,0,0,1-.09.15Zm-1.77-3.28c-.14,0-.16.11-.17.14-.15.49.88,1.93,1.72,2.62a4.18,4.18,0,0,0-.66-2.44.93.93,0,0,0-.68-.33Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408,173.88c.94,1.16,1.74,2.21,2.55,3.34s1.59,2.23,2.37,3.36q2.29,3.4,4.35,7A76.88,76.88,0,0,1,424.08,203l.08.28.11.39.19.79c.08.47.17,1,.22,1.42a22.54,22.54,0,0,1,.11,2.54,37,37,0,0,1-.38,4.5,71.62,71.62,0,0,1-1.72,8.2,112.12,112.12,0,0,1-5.38,15.32l-5.41-1.68c.87-5.09,1.71-10.26,2.33-15.3.33-2.51.54-5,.63-7.4a28.67,28.67,0,0,0-.06-3.38c-.05-.51-.12-1-.2-1.4,0-.2-.09-.35-.13-.52l-.07-.16,0-.08-.08-.19c-.87-2.18-1.94-4.36-3.07-6.53s-2.42-4.31-3.74-6.44-2.72-4.23-4.14-6.31c-.71-1-1.44-2.08-2.17-3.1L399,181Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.9,169.77c7.09,1.28,13.63,18.44,13.63,18.44L406,200.51s-5-8.68-9.05-17.08C392.6,174.29,398.31,168.22,406.9,169.77Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.67,233.28l-5,5.82,9.26,2.62s3.13-5.89.19-7.9Z",
    style: {
      fill: "#ffc3bd"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "407.39 245.38 415.15 247.2 416.96 241.72 407.7 239.1 407.39 245.38",
    style: {
      fill: "#ffc3bd"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Barrier--inject-15"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M250.25,301.17a6.26,6.26,0,0,1-.66,3.15,10.72,10.72,0,0,1-1.81,2.6,24.25,24.25,0,0,1-4.82,3.79,61.25,61.25,0,0,1-10.89,5,143.72,143.72,0,0,1-23,5.86,269,269,0,0,1-47,3.9,269,269,0,0,1-46.95-3.9,144,144,0,0,1-23-5.86,61.16,61.16,0,0,1-10.88-5,24.3,24.3,0,0,1-4.83-3.79,11,11,0,0,1-1.81-2.6,6.37,6.37,0,0,1-.66-3.15.5.5,0,0,1,1-.05v.05a6.77,6.77,0,0,0,2.84,4.28,22.14,22.14,0,0,0,4.79,2.74,62.6,62.6,0,0,0,10.79,3.47Q99,313,104.72,313.9c3.78.6,7.58,1.16,11.39,1.57a423.7,423.7,0,0,0,46.05,2.36,423.57,423.57,0,0,0,46.05-2.36c3.82-.41,7.61-1,11.39-1.57s7.54-1.33,11.23-2.24a62.6,62.6,0,0,0,10.79-3.47,22.21,22.21,0,0,0,4.8-2.74,6.8,6.8,0,0,0,2.83-4.28v-.05a.5.5,0,0,1,.56-.43A.51.51,0,0,1,250.25,301.17Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.25,301.17a6.26,6.26,0,0,1-.66,3.15,10.72,10.72,0,0,1-1.81,2.6,24.25,24.25,0,0,1-4.82,3.79,61.25,61.25,0,0,1-10.89,5,143.72,143.72,0,0,1-23,5.86,269,269,0,0,1-47,3.9,269,269,0,0,1-46.95-3.9,144,144,0,0,1-23-5.86,61.16,61.16,0,0,1-10.88-5,24.3,24.3,0,0,1-4.83-3.79,11,11,0,0,1-1.81-2.6,6.37,6.37,0,0,1-.66-3.15.5.5,0,0,1,1-.05v.05a6.77,6.77,0,0,0,2.84,4.28,22.14,22.14,0,0,0,4.79,2.74,62.6,62.6,0,0,0,10.79,3.47Q99,313,104.72,313.9c3.78.6,7.58,1.16,11.39,1.57a423.7,423.7,0,0,0,46.05,2.36,423.57,423.57,0,0,0,46.05-2.36c3.82-.41,7.61-1,11.39-1.57s7.54-1.33,11.23-2.24a62.6,62.6,0,0,0,10.79-3.47,22.21,22.21,0,0,0,4.8-2.74,6.8,6.8,0,0,0,2.83-4.28v-.05a.5.5,0,0,1,.56-.43A.51.51,0,0,1,250.25,301.17Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.93,301.17a6.37,6.37,0,0,1-.66,3.15,10.72,10.72,0,0,1-1.81,2.6,24.3,24.3,0,0,1-4.83,3.79,61.16,61.16,0,0,1-10.88,5,144,144,0,0,1-23,5.86,284.55,284.55,0,0,1-93.9,0,143.72,143.72,0,0,1-23-5.86,61.16,61.16,0,0,1-10.88-5,24,24,0,0,1-4.83-3.79,10.72,10.72,0,0,1-1.81-2.6,6.26,6.26,0,0,1-.66-3.15.5.5,0,0,1,1-.05v.05a6.8,6.8,0,0,0,2.83,4.28,22.21,22.21,0,0,0,4.8,2.74,62.6,62.6,0,0,0,10.79,3.47c3.69.91,7.45,1.65,11.23,2.24s7.57,1.16,11.39,1.57a423.57,423.57,0,0,0,46,2.36,423.7,423.7,0,0,0,46.05-2.36c3.81-.41,7.61-1,11.39-1.57s7.53-1.33,11.23-2.24a62.6,62.6,0,0,0,10.79-3.47,21.91,21.91,0,0,0,4.79-2.74,6.77,6.77,0,0,0,2.84-4.28v-.05a.5.5,0,0,1,.56-.43A.52.52,0,0,1,425.93,301.17Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M425.93,301.17a6.37,6.37,0,0,1-.66,3.15,10.72,10.72,0,0,1-1.81,2.6,24.3,24.3,0,0,1-4.83,3.79,61.16,61.16,0,0,1-10.88,5,144,144,0,0,1-23,5.86,284.55,284.55,0,0,1-93.9,0,143.72,143.72,0,0,1-23-5.86,61.16,61.16,0,0,1-10.88-5,24,24,0,0,1-4.83-3.79,10.72,10.72,0,0,1-1.81-2.6,6.26,6.26,0,0,1-.66-3.15.5.5,0,0,1,1-.05v.05a6.8,6.8,0,0,0,2.83,4.28,22.21,22.21,0,0,0,4.8,2.74,62.6,62.6,0,0,0,10.79,3.47c3.69.91,7.45,1.65,11.23,2.24s7.57,1.16,11.39,1.57a423.57,423.57,0,0,0,46,2.36,423.7,423.7,0,0,0,46.05-2.36c3.81-.41,7.61-1,11.39-1.57s7.53-1.33,11.23-2.24a62.6,62.6,0,0,0,10.79-3.47,21.91,21.91,0,0,0,4.79-2.74,6.77,6.77,0,0,0,2.84-4.28v-.05a.5.5,0,0,1,.56-.43A.52.52,0,0,1,425.93,301.17Z",
    style: {
      fill: "#fff",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.07,
    y: 268.33,
    width: 5.5,
    height: 147.17,
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72,413.44H77.6a1.47,1.47,0,0,1,1.47,1.47v.58a0,0,0,0,1,0,0h-8.5a0,0,0,0,1,0,0v-.58A1.47,1.47,0,0,1,72,413.44Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 71.66,
    y: 299.53,
    width: 6.33,
    height: 3.29,
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 72.07,
    y: 302.82,
    width: 5.5,
    height: 0.76,
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 74.82,
    cy: 266.39,
    r: 4.6,
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422.43,
    y: 268.33,
    width: 5.5,
    height: 147.17,
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M422.4,413.44H428a1.47,1.47,0,0,1,1.47,1.47v.58a0,0,0,0,1,0,0h-8.5a0,0,0,0,1,0,0v-.58A1.47,1.47,0,0,1,422.4,413.44Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422.01,
    y: 299.53,
    width: 6.33,
    height: 3.29,
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 422.43,
    y: 302.82,
    width: 5.5,
    height: 0.76,
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 425.18,
    cy: 266.39,
    r: 4.6,
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.25,
    y: 268.33,
    width: 5.5,
    height: 147.17,
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.22,413.44h5.56a1.47,1.47,0,0,1,1.47,1.47v.58a0,0,0,0,1,0,0h-8.5a0,0,0,0,1,0,0v-.58A1.47,1.47,0,0,1,247.22,413.44Z",
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.83,
    y: 299.53,
    width: 6.33,
    height: 3.29,
    style: {
      fill: "#19A49C"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 247.25,
    y: 302.82,
    width: 5.5,
    height: 0.76,
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 250,
    cy: 266.39,
    r: 4.6,
    style: {
      fill: "#19A49C"
    }
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQueue);
export default __webpack_public_path__ + "static/media/queue.78a21b89c40ddc04e95944259822213e.svg";
export { ForwardRef as ReactComponent };